<template>
  <header class="main-menu">
    <div class="container">
      <section class="main-menu__logo">
        <a href="/" class="logo">
          <img src="../assets/logo.svg">
        </a>
        <button class="menu-toggle" @click="toggleMenu">
          <span v-if="!isMenuOpen">&#9776;</span>
          <span v-else>&times;</span>
        </button>
        <div class="overlay" v-if="isMenuOpen" @click="toggleMenu"></div>
          <div class="main-menu__links" v-bind:class="{ open: isMenuOpen }">
            <a :class="{ active: isActiveRoute('/companies') }" href="/companies">
              Presenting Companies
            </a>
            <a :class="{ active: isActiveRoute('/venue') }" href="/venue">
              Venue
            </a>
            <a :class="{ active: isActiveRoute('/entertainment') }" href="/entertainment">
              Entertainment
            </a>
            <a href="https://schedule.puertorico.srax.com/"
            target="_blank">
              2024 Agenda
            </a>
            <generalformcta :buttonText="buttonText"/>
        </div>
      </section>
    </div>
  </header>
</template>

<style lang="scss" scoped>
  @import '@/styles/components/menu.scss';
</style>

<script>
import generalformcta from '@/components/generalformcta.vue';

export default {
  name: 'main menu',
  data() {
    return {
      isMenuOpen: false
    };
  },
  components: {
    generalformcta
  },
  props: {
    buttonText: String
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    isActiveRoute(route) {
      return this.$route.path === route;
    }
  }
};
</script>

<style lang="scss">
@import '@/styles/import/variables.scss';
@import '@/styles/import/mixins.scss';

  .main-menu {
    .formcta {
      &__btn {
        padding: 7px 20px;
        @include between ($breakpoint_lg, $breakpoint_xl) {
          padding: 7px 12px;
        }
        @include upto (650px) {
          margin: 0;
          padding: 7px 40px;
        }
      }
    }
  }
</style>